import { Suspense, lazy } from 'react'

/**
 * The cropper, loaded only when somebody is actually cropping.
 *
 * It is the only thing in the client that needs an image-manipulation
 * library, and it is reached from one screen. Importing it lazily keeps it off
 * every other page's download.
 */
const Cropper = lazy(async () => ({
  default: (await import('./AvatarCropper')).AvatarCropper,
}))

export function AvatarCropperField(props: {
  file: File | null
  saving: boolean
  onCancel: () => void
  onConfirm: (cropped: File) => void
}) {
  // Nothing to show until a file is chosen, so the chunk is not even
  // requested until then.
  if (!props.file) return null

  return (
    <Suspense fallback={null}>
      <Cropper {...props} />
    </Suspense>
  )
}
